import { useCallback } from 'react';
import { Field } from 'react-final-form';

import { FieldType } from '~src/types';
import SelectorHandler from '~src/modules/okrs/manageObjectives/shared/SelectorHandler';
import { OkrLabel } from '~src/store/okrs/interfaces';
import LabelSelector from '~src/modules/okrs/manageObjectives/shared/labels/LabelSelector';
import { LabelsWrapper } from '~src/modules/okrs/manageObjectives/shared/shared.sc';

const ObjectiveLabels = () => {
  const renderLabels = useCallback(({ input }: FieldType) => {
    const onChange = (param: OkrLabel[]) => {
      input.onChange(param);
    };
    return <LabelSelector labels={input.value || []} onChange={onChange} />;
  }, []);

  return (
    <LabelsWrapper>
      <SelectorHandler hoverTextKey="x.objective.add.icon.labels" iconName="iconLabel">
        {(_, select, blur) => (
          <Field name="labels" label={'REPLACE'} children={renderLabels} onFocus={select} onBlur={blur} />
        )}
      </SelectorHandler>
    </LabelsWrapper>
  );
};

export default ObjectiveLabels;
